module.exports = __webpack_public_path__ + "img/D1.4adcf1c8.svg";